import { useState } from "react";
import Modal, { ModalBody } from "../../../Components/Modal/Modal";
import classes from "./DropdownModal.module.css";
import PrimaryButton from "../../../Components/Buttons/PrimaryButton/PrimaryButton";
import { useSelector } from "react-redux";
import { urls } from "../../../Routes/Urls";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const logoImg = "/Assets/Icons/logo.jpg";

const DropdownModal = ({
  searchQuery,
  setSearchQuery,
  filteredCountries,
  onClose,
  setSelectedCountry,
  selectedCountry,
  setShowModal
}) => {
  const [isChanging, setIsChanging] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const history = useHistory()

  const handleSelect = (e, country) => {
    e.stopPropagation();
    setSelectedCountry(country);
    setSearchQuery("");
    setIsChanging(false);
  };

  const handleChange = () => {
      setIsChanging(true)
  }

  return (
    <Modal
      title={
        <div className={classes.modalTitle}>
          <img src={logoImg} alt="Rare Biblio" />
          <h2>Rare Biblio</h2>
        </div>
      }
      className={classes.modal}
      onClose={onClose}
    >
      <ModalBody>
        <div className={classes.container}>
          {!isChanging ? (
            <div className={classes.currentCountry}>
              <div
                className={classes.bodyTitle}
              >
                <p className={classes.currentLabel}>
                  You're currently browsing in
                </p>
                <div className={classes.countryInfo}>
                  <i
                    className={`${classes.flag} ${classes["flag-16"]} ${
                      classes[`flag-${selectedCountry?.code.toLowerCase()}`]
                    }`}
                  />
                  <span className={classes.countryName}>
                    {`${selectedCountry?.code} ( ${selectedCountry?.currency} )`}
                  </span>
                </div>
              </div>
              <p className={classes.infoText}>
                Prices and shipping options are tailored for your selected
                region.
              </p>
              <PrimaryButton
                onClick={handleChange}
                className={classes.changeButton}
              >
                Change currency
              </PrimaryButton>

              <p className={classes.disclaimer}>
                NOTE : Changing the country will clear your cart.
              </p>
            </div>
          ) : (
            <div className={classes.dropdown}>
              <PrimaryButton
                onClick={() => {setIsChanging(false);setSearchQuery("")}}
                className={classes.backButton}
              >
                ← Back
              </PrimaryButton>
                <div className={classes.searchContainer}>
                  <input
                    type="text"
                    placeholder="Search countries..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className={classes.search}
                    autoFocus
                  />
                </div>
              <div className={classes.list}>
                {filteredCountries.map((country) => (
                  <div
                    key={country.code}
                    className={classes.item}
                    onClick={(e) => handleSelect(e, country)}
                  >
                    <i
                      className={`${classes.flag} ${classes["flag-16"]} ${
                        classes[`flag-${country.code.toLowerCase()}`]
                      }`}
                    />
                    <span>{country.name}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DropdownModal;
